/* istanbul ignore file */
/* tslint:disable */
 
import type { NewsletterCreate } from '../models/NewsletterCreate';
import type { NewsletterFull } from '../models/NewsletterFull';
import type { NewsletterUpdate } from '../models/NewsletterUpdate';
import type { PaginatedNewsletterListList } from '../models/PaginatedNewsletterListList';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class NewsletterService {

  /**
   * @param page A page number within the paginated result set.
   * @param pageSize Number of results to return per page.
   * @returns PaginatedNewsletterListList 
   * @throws ApiError
   */
  public static newsletterList(
page?: number,
pageSize?: number,
): CancelablePromise<PaginatedNewsletterListList> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/newsletter/',
      query: {
        'page': page,
        'page_size': pageSize,
      },
    });
  }

  /**
   * @param id 
   * @returns NewsletterFull 
   * @throws ApiError
   */
  public static newsletterRetrieve(
id: string,
): CancelablePromise<NewsletterFull> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/newsletter/{id}/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @returns void 
   * @throws ApiError
   */
  public static newsletterDeleteDestroy(
id: string,
): CancelablePromise<void> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/newsletter/{id}/delete/',
      path: {
        'id': id,
      },
    });
  }

  /**
   * @param id 
   * @param formData 
   * @returns NewsletterFull 
   * @throws ApiError
   */
  public static newsletterUpdateUpdate(
id: string,
formData?: NewsletterUpdate,
): CancelablePromise<NewsletterFull> {
    return __request(OpenAPI, {
      method: 'PUT',
      url: '/newsletter/{id}/update/',
      path: {
        'id': id,
      },
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

  /**
   * @param formData 
   * @returns NewsletterFull 
   * @throws ApiError
   */
  public static newsletterCreateCreate(
formData: NewsletterCreate,
): CancelablePromise<NewsletterFull> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/newsletter/create/',
      formData: formData,
      mediaType: 'multipart/form-data',
    });
  }

}
